import { forwardRef, type Ref, type SVGProps } from "react";
const IconStopFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M26.833 3H5.167A2.173 2.173 0 0 0 3 5.167v21.666C3 28.025 3.975 29 5.167 29h21.666A2.173 2.173 0 0 0 29 26.833V5.167A2.173 2.173 0 0 0 26.833 3" /></svg>;
const ForwardRef = forwardRef(IconStopFilledSVG);
ForwardRef.displayName = "IconStopFilled";
export { ForwardRef as IconStopFilled };